import * as types from './mutation-types';

export const setScannedDevices = async ({ commit }, payload) => { commit(types.SCANNED, payload) };
export const addDevice = async ({ commit }, payload) => { commit(types.ADD_SCANNED, payload) };
export const connectDevice = async ({ commit }, payload) => { commit(types.CONNECTED, payload) };
export const disconnectDevice = async ({ commit }) => { commit(types.CONNECTED, {}) };
export const setTerminalData = async ({ commit }, payload) => { commit(types.TERMINAL_DATA, payload) };
export const clearTerminalData = async ({ commit }) => { commit(types.CLEAR_TERMINAL_DATA) };
export const activeTab = async ({ commit }, payload) => { commit(types.TAB, payload) };
export const setStatusBtTab = async ({ commit }, payload) => { commit(types.IS_ENABLE_BT_TAB, payload) };
export const setStatusUsbTab = async ({ commit }, payload) => { commit(types.IS_ENABLE_USB_TAB, payload) };
export const setUpdateOsStatus = async ({ commit }, payload) => { commit(types.IS_ENABLE_UPDATE_OS, payload) };

export default {
    setScannedDevices,
    addDevice,
    connectDevice,
    disconnectDevice,
    setTerminalData,
    clearTerminalData,
    activeTab,
    setStatusBtTab,
    setStatusUsbTab,
    setUpdateOsStatus,
};



// WEBPACK FOOTER //
// ./src/store/modules/device/actions.js